import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from 'react';
import PropTypes from 'prop-types';
import { debounce, noop, isNumber } from 'lodash';
import moment from 'moment';
import { SelectField, DateField } from '@unite-us/ui';
import '../../InsuranceInformation/stylesheets/PaymentsInsuranceFields.scss';
import { theme } from '../../../../tailwind.config';
import today from '../../utils/today';
import { SocialInsuranceStartDate, SocialInsuranceEndDate } from './SocialInsuranceDates';
import PlanRequirementsDisplay from './PlanRequirementsDisplay';
import PrimaryInsuranceDisplay from './PrimaryInsuranceDisplay';
import ExistingInsurancePlans from './ExistingInsurancePlans';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
export var SocialInsuranceFields = function SocialInsuranceFields(_ref) {
  var planIdTuple = _ref.planIdTuple,
    startDateTuple = _ref.startDateTuple,
    endDateTuple = _ref.endDateTuple,
    primaryInsuranceIdTuple = _ref.primaryInsuranceIdTuple,
    disableEnrollmentTuple = _ref.disableEnrollmentTuple,
    planOptions = _ref.planOptions,
    loadPlanOptions = _ref.loadPlanOptions,
    isStartDateRequired = _ref.isStartDateRequired,
    clientHasConsent = _ref.clientHasConsent,
    isSamePayer = _ref.isSamePayer,
    contactId = _ref.contactId;
  var _planIdTuple = _slicedToArray(planIdTuple, 2),
    planId = _planIdTuple[0],
    setPlanId = _planIdTuple[1];
  var _startDateTuple = _slicedToArray(startDateTuple, 2),
    startDate = _startDateTuple[0],
    setStartDate = _startDateTuple[1];
  var _endDateTuple = _slicedToArray(endDateTuple, 2),
    endDate = _endDateTuple[0],
    setEndDate = _endDateTuple[1];
  var _disableEnrollmentTup = _slicedToArray(disableEnrollmentTuple, 2),
    disableEnrollment = _disableEnrollmentTup[0],
    setDisableEnrollment = _disableEnrollmentTup[1];
  var shouldPreventOverlappingRequests = useFeatureFlag('pays-3513-prevent-overlapping-scc-and-enrollment-requests');
  var isPlanSelected = !!planId;
  var selectedPlan = _findInstanceProperty(planOptions).call(planOptions, function (plan) {
    return plan.id === planId;
  });
  var isSelectedPlanEnrollmentRequired = !!(selectedPlan !== null && selectedPlan !== void 0 && selectedPlan.enrollment_required);
  var isSelectedPlanPrimaryInsuranceRequired = (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.required_health_plans.length) > 0;
  var coveragePeriod = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.coverage_period;
  return /*#__PURE__*/React.createElement("div", {
    className: "payments-insurance-fields content-container space-y-4 py-4"
  }, /*#__PURE__*/React.createElement(SelectField, {
    className: "payments-insurance-fields__plan",
    id: "social-insurance-plan",
    label: "Social Care Coverage",
    labelKey: "display_name",
    loadOptions: debounce(loadPlanOptions, 400),
    options: _mapInstanceProperty(planOptions).call(planOptions, function (_ref2) {
      var _context;
      var id = _ref2.id,
        name = _ref2.name,
        enrollment_required = _ref2.enrollment_required;
      return {
        display_name: _concatInstanceProperty(_context = "".concat(name)).call(_context, enrollment_required ? ' (requirements)' : ''),
        value: id
      };
    }),
    placeholder: "Select...",
    searchResultLimit: 250,
    required: true,
    value: planId,
    onChange: setPlanId,
    style: {
      error: {
        height: 0
      },
      label: {
        color: theme.extend.colors['dark-blue']
      }
    }
  }), isPlanSelected && shouldPreventOverlappingRequests && /*#__PURE__*/React.createElement(ExistingInsurancePlans, {
    selectedPlan: selectedPlan,
    setDisableEnrollment: setDisableEnrollment,
    contactId: contactId
  }), isPlanSelected && isSelectedPlanPrimaryInsuranceRequired && !disableEnrollment && /*#__PURE__*/React.createElement(PrimaryInsuranceDisplay, {
    selectedPlan: selectedPlan,
    primaryInsuranceIdTuple: primaryInsuranceIdTuple,
    contactId: contactId
  }), isPlanSelected && (isSelectedPlanEnrollmentRequired ? /*#__PURE__*/React.createElement(PlanRequirementsDisplay, {
    clientHasConsent: clientHasConsent,
    isSamePayer: isSamePayer
  }) : /*#__PURE__*/React.createElement("p", null, "This plan does not require approval by the plan administrator.", isNumber(coveragePeriod) ? " The plan will be valid for ".concat(coveragePeriod, " days.") : ' The plan will be valid until it expires or the client is disenrolled.')), isStartDateRequired ? /*#__PURE__*/React.createElement("div", {
    className: "payments-insurance-date-item"
  }, /*#__PURE__*/React.createElement(DateField, {
    className: "payments-insurance-fields__coverage-start",
    id: "social-insurance-enrollment",
    label: "Start Date",
    maxDate: today(),
    placeholder: "MM/DD/YYYY",
    required: true,
    value: startDate,
    onChange: setStartDate
  }), /*#__PURE__*/React.createElement(DateField, {
    className: "payments-insurance-fields__coverage-end",
    id: "social-insurance-expiration",
    label: "End Date",
    placeholder: "MM/DD/YYYY",
    minDate: startDate ? (Number(startDate) + 86400).toString() : today(),
    isUtc: false,
    shouldDisableDate: function shouldDisableDate(date) {
      return date.isSame(moment.utc(startDate), 'day');
    },
    value: endDate,
    onChange: setEndDate
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SocialInsuranceStartDate, null), /*#__PURE__*/React.createElement(SocialInsuranceEndDate, {
    coveragePeriod: coveragePeriod
  })));
};
SocialInsuranceFields.propTypes = {
  planIdTuple: PropTypes.array.isRequired,
  startDateTuple: PropTypes.array.isRequired,
  endDateTuple: PropTypes.array.isRequired,
  primaryInsuranceIdTuple: PropTypes.array.isRequired,
  disableEnrollmentTuple: PropTypes.array.isRequired,
  planOptions: PropTypes.array,
  loadPlanOptions: PropTypes.func,
  isStartDateRequired: PropTypes.bool.isRequired,
  clientHasConsent: PropTypes.bool,
  isSamePayer: PropTypes.bool,
  contactId: PropTypes.string.isRequired,
  shouldPreventOverlappingRequests: PropTypes.bool.isRequired
};
SocialInsuranceFields.defaultProps = {
  planOptions: [],
  loadPlanOptions: noop,
  clientHasConsent: false,
  isSamePayer: false
};
//# sourceMappingURL=SocialInsuranceFields.js.map